<template>
  <v-container>
    <v-row
      class="d-flex justify-center align-center" 
      style="height: 50vh;"
    >
      <v-col>
        <v-alert
          text
          color="info"
          icon="mdi-check"
          prominent
        >
          <v-row>
            <v-col class="grow">
              <span class="headline">Sign up successful!</span>
            </v-col>
            <v-col class="shrink">
              <router-link :to="{ name: 'Home' }">
                <v-btn
                  color="info"
                  outlined
                  rounded
                >
                  Take me home
                </v-btn>
              </router-link>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import User from '@/mixins/User'
  export default {
    name: 'Welcome',
    mixins: [ User ]
  }
</script>
